/**
 * OrderInfo['OrderType']
 * There are a number of order types throughout these interfaces.
 * This may or may not be the type for which you are looking.
 */
export var OrderType;
(function (OrderType) {
    OrderType[OrderType["None"] = 0] = "None";
    OrderType[OrderType["Delivery"] = 1] = "Delivery";
    OrderType[OrderType["Pickup"] = 2] = "Pickup";
})(OrderType || (OrderType = {}));
/**
 * CouponApplyViewModel['CouponType']
 */
export var CouponType;
(function (CouponType) {
    CouponType[CouponType["None"] = 0] = "None";
    CouponType[CouponType["Percent"] = 10] = "Percent";
    CouponType[CouponType["Dollars"] = 20] = "Dollars";
    CouponType[CouponType["Days"] = 30] = "Days";
    CouponType[CouponType["PerMeal"] = 40] = "PerMeal";
    CouponType[CouponType["PerItem"] = 50] = "PerItem";
})(CouponType || (CouponType = {}));
